import { useQuery } from "@tanstack/solid-query";
import { type Accessor, createMemo } from "solid-js";
import { createJobOfferQueryOptions } from "@/domains/job-offer/api";
import { useFreelanceSearchStore } from "../store/freelance-search-store";

export type OfferTaxonomy = { category: string; subcategories: string[] };

/**
 * Category and subcategories of the job offer the active-search session is linked to,
 * or `null` when the search is not offer-linked or the offer is still loading.
 *
 * Reads the SAME query as `useIsFixedOfferContext` (same key): no extra request and no
 * second first-read that could suspend the route.
 */
export const useOfferTaxonomy = (): Accessor<OfferTaxonomy | null> => {
  const [storeState] = useFreelanceSearchStore();

  const query = useQuery(() =>
    createJobOfferQueryOptions(storeState.jobOfferId ?? ""),
  );

  return createMemo(() => {
    if (storeState.researchType !== "from_offer") return null;
    if (!storeState.jobOfferId) return null;
    const offer = query.data?.job_offer;
    if (!offer) return null;
    return {
      category: offer.job_category ?? "",
      subcategories: offer.job_subcategory ?? [],
    };
  });
};
